import React from "react";
import {
  LoginWrapper,
  FormContainer,
  Title,
  Button,
  LeftContainer,
  LoginLogo,
} from "../Login/Login.styles";
import LoginLogoSVG from "@assets/img/login-logo.svg";
import { useNavigate } from "react-router-dom";
import LoginLeftContainer from "../Login/LoginLeftContainer";
import styled from "styled-components";
import { CheckCircle } from "lucide-react";
import { theme } from "@src/theme";

const Content = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 80%;
  max-width: 400px;
  margin: 0 auto;
  padding: 2rem;
`;

const EmailConfirmed: React.FC = () => {
  const navigate = useNavigate();

  const goToLogin = (): void => {
    navigate("/login");
  };

  return (
    <LoginWrapper>
      <FormContainer>
        <Content>
          <LoginLogo src={LoginLogoSVG} />
          <Title>EMAIL CONFIRMED</Title>
          <Title>
            Your email has been successfully confirmed. You can now log in.
          </Title>
          <CheckCircle size={70} color={theme.colors.green} />
          <Button type="button" onClick={goToLogin}>
            BACK TO LOGIN
          </Button>
        </Content>
      </FormContainer>
      <LeftContainer>
        <LoginLeftContainer />
      </LeftContainer>
    </LoginWrapper>
  );
};

export default EmailConfirmed;
